import Swiper, { Autoplay, Pagination } from 'swiper';
const initSwiper = (selector) => {
    if (!selector) {
        return false;
    }
    return new Swiper(selector, {
        spaceBetween: 24,
        slidesPerView: 3,
        modules: [Pagination],
        pagination: {
            el: '.js-similar-pagination',
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
        },
    });
};
export const initBannerSlider = () => {
    var _a;
    const sliderElement = document.querySelector('.js-banner-slider');
    if (!sliderElement)
        return false;
    const sliderScrollPeriod = Number.parseInt((_a = sliderElement.dataset.scroll_period) !== null && _a !== void 0 ? _a : '2000', 10);
    return new Swiper('.js-banner-slider', {
        spaceBetween: 5,
        slidesPerView: 1,
        modules: [Autoplay],
        effect: 'fade',
        autoplay: sliderScrollPeriod ? { delay: sliderScrollPeriod } : false,
    });
};
export default initSwiper;
